import type { FC, ReactNode } from 'react'
import type { OpenStatus as OpenStatusValue } from '@/lib/schedule'

import { useEffect, useState } from 'react'
import { cn } from '@/lib/utils'
import { countOpenDays, getOpenStatus } from '@/lib/schedule'

interface OpenStatusProps {
    className?: string
}

// Live open or closed badge. It shows the opening days until the visitor's clock is known after load.
export const OpenStatus: FC<OpenStatusProps> = ({ className }): ReactNode => {
    const [status, setStatus] = useState<OpenStatusValue | null>(null)

    useEffect(() => {
        const update = (): void => setStatus(getOpenStatus(new Date()))

        update()

        const timer = window.setInterval(update, 60000)

        return () => window.clearInterval(timer)
    }, [])

    const openDays = countOpenDays()
    const label = status ? status.label : `Open ${openDays} days a week`

    return (
        <span
            className={cn(
                'inline-flex items-center gap-2 rounded-full bg-white/95 px-3.5 py-2 text-sm font-semibold text-ink shadow-lg shadow-ink/10 ring-1 ring-ink/5 backdrop-blur',
                className
            )}
        >
            <span className='relative flex size-2.5'>
                {status?.isOpen && (
                    <span className='absolute inline-flex size-full animate-ping rounded-full bg-emerald-400 opacity-75 motion-reduce:hidden' />
                )}

                <span
                    className={cn(
                        'relative inline-flex size-2.5 rounded-full',
                        status ? (status.isOpen ? 'bg-emerald-500' : 'bg-rose-500') : 'bg-aqua-deep'
                    )}
                />
            </span>

            <span>
                {label}
            </span>
        </span>
    )
}
